import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

export default function AccountSkeletonLoader({ isLoadingSearchedUserData }) {
    if (!isLoadingSearchedUserData) return null;

    return (
        <div>
            <Stack spacing={1}>
                {/* For variant="text", adjust the height via font-size */}
                <Skeleton variant="rectangular" sx={{ fontSize: '10rem', bgcolor: 'grey.500' }} />
                {/* For other variants, adjust the size with `width` and `height` */}
                <Skeleton variant="circular" width={150} height={150} sx={{ bgcolor: 'grey.500', position: 'relative', bottom: '50px', left: '20px' }} />
                <Skeleton variant="rounded" height={60} sx={{ bgcolor: 'grey.500', position: 'relative', bottom: '50px' }} />
                <Skeleton variant="text" width={"50%"} height={60} sx={{ bgcolor: 'grey.500', position: 'relative', bottom: '50px' }} />
            </Stack>
        </div>
    )
}
